import { APEX_K9_MARK } from '../branding/apexK9.js';

export type DashboardRoleTourDefinition = {
  key: string;
  label: string;
  description: string;
  features: readonly string[];
};

/** Role tab copy aligned with DashboardPage roleModules (features users can perform). */
export const DASHBOARD_ROLE_TOUR_DEFINITIONS: readonly DashboardRoleTourDefinition[] = [
  {
    key: 'coordinator',
    label: 'Coordinator',
    description:
      'Primary administrator for your organization\'s training program.',
    features: [
      'Edit agency information',
      'Create and cancel events',
      'Appoint instructors and training managers',
      'Register for trainings',
    ],
  },
  {
    key: 'training_manager',
    label: 'Training Manager',
    description: 'Manages training events and instructor coordination.',
    features: [
      'Manage events and rosters',
      'Coordinate instructors',
      'Track performance',
      'Cannot appoint other training managers',
    ],
  },
  {
    key: 'supervisor',
    label: 'Supervisor',
    description: 'Supervises team members and training participation.',
    features: [
      'Manage your team',
      'Approve registrations',
      'Track progress',
      'Browse available events',
    ],
  },
  {
    key: 'instructor',
    label: 'Instructor',
    description: 'Delivers courses and manages class rosters.',
    features: [
      'Modify event rosters',
      'View rosters and print sign-in sheets',
      'Manage your instructor profile',
      'Cannot modify agency details',
    ],
  },
  {
    key: 'attendee',
    label: 'Attendee',
    description: 'Find, register for, and track your own training.',
    features: [
      'Search and register for events',
      'Access certificates',
      'Track progress and history',
    ],
  },
  {
    key: 'tacticore',
    label: 'TactiCore™',
    description: 'Law enforcement lesson planning and exam tools.',
    features: [
      'Build lesson plans',
      'Create exams',
      'Manage organization content',
      'Sync to the cloud',
    ],
  },
  {
    key: 'k9_ops',
    label: APEX_K9_MARK,
    description: 'K9 operations, tracking, and training records.',
    features: [
      'Manage K9 units and operations',
      'Track detection and training sessions',
      'Review records and expenses',
    ],
  },
] as const;

export function roleTabTourTarget(roleKey: string): string {
  return `[data-tour-stable="role-tab-${roleKey}"]`;
}

export function shouldSkipRoleTabTourStep(
  roleKey: string,
  root: ParentNode = document,
): boolean {
  return root.querySelector(`[data-tour-stable="role-tab-${roleKey}"]`) === null;
}

export function formatDashboardRoleTourContent(
  role: DashboardRoleTourDefinition,
): string {
  return `${role.description}\n\nWhat you can do:\n• ${role.features.join('\n• ')}`;
}
